import PropTypes from 'prop-types';
import Option from './Option';
import Search from './Search';
import Select from './Select';

export default function Controls({
	categories,
	clearSearchField,
	setSearchValue,
	setCategoryFilterTerm,
	handleViewChange,
	getLabel,
	searchValue,
	categoryFilterTerm,
	view,
	isFiltered,
}) {
	return (
		<div className="feature__controls">
			<Option getLabel={getLabel} view={view} handleChange={handleViewChange} />
			{!isFiltered && Object.keys(categories).length ? (
				<Select
					categories={categories}
					value={categoryFilterTerm}
					setValue={setCategoryFilterTerm}
					searchValue={searchValue}
					clearSearchField={clearSearchField}
				/>
			) : null}
			<Search searchValue={searchValue} setSearchValue={setSearchValue} getLabel={getLabel} />
		</div>
	);
}

Controls.propTypes = {
	categories: PropTypes.object,
	categoryFilterTerm: PropTypes.string,
	clearSearchField: PropTypes.func,
	handleViewChange: PropTypes.func,
	isFiltered: PropTypes.bool,
	getLabel: PropTypes.func,
	searchValue: PropTypes.string,
	setCategoryFilterTerm: PropTypes.func,
	setSearchValue: PropTypes.func,
	view: PropTypes.string,
};
